import React, { useState, useEffect, useCallback, useMemo } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import FormFilter from "../NFormFilter";
import NPriorityFilter from "./NPriorityFilter";
import NFilterBadge from "./NFilterBadge";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Container, Collapse } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { NSearchStudents } from "components";
import {
  loadClientFilters,
  updateClientFilters,
} from "store/actions/site.actions";
import { APP_MODULES, storeClientAllFilters } from "utils";
import taskStyles from "containers/Task/Task.module.css";

import { SEARCH } from "./constants";

const {
  TASK: { FILTER_NAME: FILTER_TASK },
} = APP_MODULES;

const NDynamicFilters = ({
  panel,
  onGetSingleStudent,
  onGetSuggestStudents,
  onLazySecondList,
  isPendingList = false,
  showPriorityFilter = false,
  filterNameLS = FILTER_TASK,
}) => {
  const dispatch = useDispatch();
  const { clientFilters } = useSelector((state) => state.site);
  const [tempFilters, setTempFilters] = useState({});
  const [expandFilters, setExpandFilters] = useState(false);

  const filtersData = useMemo(() => clientFilters.data[panel] || [], [
    clientFilters.data,
    panel,
  ]);

  const filtersCount = useMemo(() => {
    const currentFilters = Object.keys({ ...clientFilters.filters[panel] });
    let count = 0;
    count = currentFilters.length;
    return count;
  }, [clientFilters.filters, panel]);

  const filtersApplied = useMemo(() => {
    const currentFilters = Object.keys({ ...clientFilters.filters[panel] });

    const list_filter = [];
    const allItems = {
      1: "SI",
      0: "NO",
      True: "SI",
      False: "NO",
      undefined: "NO",
    };
    currentFilters.forEach((filter) => {
      const item = filtersData.find(
        (element) => element.filter_field === filter
      );

      // eslint-disable-next-line prefer-destructuring
      let value = _.get(
        allItems,
        clientFilters.filters[panel][filter],
        clientFilters.filters[panel][filter]
      );
      if (item) {
        let res = { key: item["label"], value: value, filter: filter };
        list_filter.push(res);
      }
    });

    return list_filter;
  }, [clientFilters.filters, panel, filtersData]);

  const updateSessionFilters = useCallback(() => {
    const isEmpty = Object.keys(tempFilters).length === 0;
    if (isEmpty) return false;

    dispatch(updateClientFilters(tempFilters));
    storeClientAllFilters(tempFilters.filters[panel], filterNameLS);
  }, [dispatch, tempFilters, panel, filterNameLS]);

  const handleFilterChanged = useCallback(
    (content) => {
      if (_.isEqual(clientFilters.filters[panel], content) === false) {
        setTempFilters({
          data: clientFilters.data,
          filters: { ...clientFilters.filters, ...{ [panel]: content } },
        });
      }
    },
    [clientFilters.data, clientFilters.filters, panel]
  );

  const renderFilterGroup = useCallback(() => {
    if (filtersData.length === 0 || !panel) return null;
    const hasFilters = Object.keys(clientFilters.filters || {}).length > 0;
    const filtersetData = hasFilters ? clientFilters.filters[panel] : {};

    return (
      <>
        <Row className="mt-3">
          <Col>
            <div className={taskStyles.filterTitle}>Filtrar por:</div>
          </Col>
        </Row>
        <Row>
          <Col className="p-0">
            <Container className="mt-2">
              <FormFilter
                data={filtersData}
                onChange={handleFilterChanged}
                filterset={filtersetData ?? {}}
                isDisabled={isPendingList}
              />
            </Container>
          </Col>
        </Row>
      </>
    );
  }, [
    panel,
    filtersData,
    clientFilters.filters,
    isPendingList,
    handleFilterChanged,
  ]);

  useEffect(() => {
    dispatch(loadClientFilters());
  }, [dispatch]);

  useEffect(() => {
    // Apply filters
    updateSessionFilters();
    onLazySecondList();
  }, [tempFilters, updateSessionFilters, onLazySecondList]);

  const deletefilter = (filter) => {
    let filters = clientFilters.filters[panel];
    delete filters[filter["filter"]];
    setTempFilters({
      data: clientFilters.data,
      filters: { ...clientFilters.filters, ...{ [panel]: filters } },
    });
  };

  const renderFilterBadges = () => {
    if (Object.keys(filtersApplied).length === 0) return null;
    return filtersApplied.map((element) => {
      //const [key, value] = element;
      return (
        <NFilterBadge
          key={element["key"]}
          filterInfo={element}
          onClickDelete={deletefilter}
        />
      );
    });
  };

  return (
    <Container className={taskStyles.filterBlock}>
      <Row style={{ padding: "0 15px" }} className="mt-2 mb-3">
        <Col xs="7">
          <NSearchStudents
            filterKey={SEARCH.TASK.FILTER_KEY}
            fieldName={SEARCH.TASK.FIELD_NAME}
            onChange={onGetSingleStudent}
            asyncSearch={onGetSuggestStudents}
            isDisabled={isPendingList}
          />
        </Col>
        <Col xs="2">
          {showPriorityFilter && panel === APP_MODULES.TASK.ID ? (
            <NPriorityFilter isDisabled={isPendingList} />
          ) : null}
        </Col>
        <Col xs="3">
          {filtersData.length > 0 ? (
            <span
              className={`btn ${taskStyles.filterButton}`}
              onClick={() => {
                if (!isPendingList) setExpandFilters((sw) => !sw);
              }}
              aria-hidden="true"
            >
              {expandFilters ? "Ocultar" : "Mostrar"} Filtros Avanzados (
              {filtersCount}) &nbsp;&nbsp;
              <FontAwesomeIcon
                icon={expandFilters ? faChevronUp : faChevronDown}
              />
            </span>
          ) : null}
        </Col>
        <Row style={{ margin: 0 }} className="w-100">
          <Collapse in={expandFilters}>
            <Container>{renderFilterGroup()}</Container>
          </Collapse>
        </Row>
      </Row>
      {!expandFilters ? (
        <Row style={{ padding: "0 15px" }} className="mt-2 mb-3">
          <Col>{renderFilterBadges()}</Col>
        </Row>
      ) : null}
    </Container>
  );
};

export default NDynamicFilters;
NDynamicFilters.propTypes = {
  onGetSingleStudent: PropTypes.func.isRequired,
  onGetSuggestStudents: PropTypes.func.isRequired,
  onLazySecondList: PropTypes.func.isRequired,
  panel: PropTypes.oneOf(["tasks", "students", "users"]),
  isPendingList: PropTypes.bool,
  showPriorityFilter: PropTypes.bool,
};
